/* ==========================================================================
   Jabree — K59 "What's my size?" fit finder engine (jab-k59-fitfinder.js)
   Short body quiz -> recommends size (S/M/L/XL) + length (Regular/Long) and
   AUTO-SELECTS it on the jab-pdp buy box by clicking the existing
   [data-waist] / [data-length] buttons (re-uses all variant/cart logic).
   Vanilla JS, no deps.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__jabFFLoaded) return;
  window.__jabFFLoaded = 1;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var modal = document.querySelector('[data-jkff]');
    if (!modal) return;
    var pdp = document.querySelector('.jpdp');
    if (!pdp) return;

    var $  = function (s, c) { return (c || modal).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || modal).querySelectorAll(s)); };

    /* config (size -> max estimated waist in inches) */
    var CFG = { sizes: [{ key: 'S', max: 29.25 }, { key: 'M', max: 31.25 }, { key: 'L', max: 33.25 }, { key: 'XL', max: 999 }] };
    try {
      var cfgEl = document.querySelector('[data-jkff-config]');
      if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
    } catch (e) {}
    var ORDER = ['S', 'M', 'L', 'XL'];

    var steps    = $$('[data-jkff-step]');
    var dots     = $$('[data-jkff-dots] span');
    var nextBtn  = $('[data-jkff-next]');
    var backBtn  = $('[data-jkff-back]');
    var errEl    = $('[data-ff-err]');
    var resultEl = $('[data-ff-result]');

    var INPUT_STEPS = [0, 1];         // steps that use the Next button
    var QUESTION_STEPS = 3;           // steps 0,1,2 map to the 3 dots
    var st = { unit: 'us', hft: '', hin: '', hcm: '', wt: '', waist: '', usual: '', fit: '' };
    var rec = null;
    var cur = 0;

    /* ---------- unit toggle ---------- */
    var hUS = $('[data-ff-h-us]'), hMET = $('[data-ff-h-metric]');
    var wtUnit = $('[data-ff-wt-unit]'), waistUnit = $('[data-ff-waist-unit]');
    $$('[data-ff-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.unit = b.getAttribute('data-ff-unit');
        $$('[data-ff-unit]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var us = st.unit === 'us';
        if (hUS) hUS.hidden = !us;
        if (hMET) hMET.hidden = us;
        if (wtUnit) wtUnit.textContent = us ? 'lbs' : 'kg';
        if (waistUnit) waistUnit.textContent = us ? 'in' : 'cm';
        if (errEl) errEl.hidden = true;
        validateStep0();
      });
    });

    /* ---------- step plumbing ---------- */
    function showStep(n) {
      cur = n;
      steps.forEach(function (s) { s.hidden = parseInt(s.getAttribute('data-jkff-step'), 10) !== n; });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === n && n < QUESTION_STEPS); });
      modal.classList.toggle('is-loading', n === 3);
      modal.classList.toggle('is-result', n === 4);
      backBtn.hidden = (n === 0);
      nextBtn.hidden = (INPUT_STEPS.indexOf(n) === -1);
      if (n === 0) validateStep0();
      if (n === 1) nextBtn.disabled = false;   // waist is optional
    }

    /* ---------- step 0: measurements ---------- */
    var hft = $('[data-ff-hft]'), hin = $('[data-ff-hin]'), hcm = $('[data-ff-hcm]'), wt = $('[data-ff-wt]');
    function validateStep0() {
      var w = parseFloat(wt.value);
      var hOk, wOk;
      if (st.unit === 'us') {
        var f = parseInt(hft.value, 10);
        hOk = f >= 3 && f <= 7;
        wOk = w >= 70 && w <= 400;
      } else {
        var c = parseFloat(hcm.value);
        hOk = c >= 120 && c <= 220;
        wOk = w >= 32 && w <= 180;
      }
      nextBtn.disabled = !(hOk && wOk);
      return hOk && wOk;
    }
    [hft, hin, hcm, wt].forEach(function (el) {
      if (el) el.addEventListener('input', function () { if (errEl) errEl.hidden = true; validateStep0(); });
    });

    /* ---------- step 1: waist + usual size worn (both optional) ---------- */
    var waistEl = $('[data-ff-waist]');
    $$('[data-ff-usual]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.usual = b.getAttribute('data-ff-usual') || '';
        $$('[data-ff-usual]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      });
    });

    /* ---------- Next / Back ---------- */
    nextBtn.addEventListener('click', function () {
      if (cur === 0) {
        if (!validateStep0()) { if (errEl) errEl.hidden = false; return; }
        st.hft = hft.value; st.hin = hin.value || '0'; st.hcm = hcm.value; st.wt = wt.value;
        showStep(1);
      } else if (cur === 1) {
        st.waist = (waistEl && waistEl.value) ? waistEl.value : '';
        showStep(2);
      }
    });
    backBtn.addEventListener('click', function () {
      if (cur === 1) showStep(0);
      else if (cur === 2) showStep(1);
      else if (cur === 4) showStep(0);
      else if (cur > 0) showStep(cur - 1);
    });

    /* ---------- step 2: knee-length preference (tap to advance) ---------- */
    $$('[data-ff-fit]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.fit = b.getAttribute('data-ff-fit');
        $$('[data-ff-fit]').forEach(function (x) { x.classList.toggle('is-sel', x === b); });
        runLoading();
      });
    });

    /* ---------- recommendation ---------- */
    function availableWaists() {
      return $$('[data-waist]', pdp).map(function (b) { return b.getAttribute('data-waist'); });
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function bodyMetrics() {
      var heightIn, weightLb;
      if (st.unit === 'us') {
        heightIn = (parseInt(st.hft, 10) || 0) * 12 + (parseInt(st.hin, 10) || 0);
        weightLb = parseFloat(st.wt) || 0;
      } else {
        heightIn = (parseFloat(st.hcm) || 0) / 2.54;
        weightLb = (parseFloat(st.wt) || 0) * 2.2046;
      }
      return { heightIn: heightIn, weightLb: weightLb };
    }
    /* Effective waist for sizing.
       K59 baselines S28/M30/L32/XL34 (ranges overlap: S 28-31, M 30-33, L 32-35, XL 34-37).
       The waistband stretches ~+3" and the volley drawstring cinches down, so a touch big is
       recoverable and a touch small is a return. The size cuts in the config therefore sit
       BELOW each baseline = a deliberate lean toward the larger size.

       Two branches, and they must agree on direction: TALLER ALWAYS READS BIGGER.
       (The old estimate branch subtracted for height, so a 6'2" customer scored SMALLER than a
        5'10" one at the same weight, and typing 6'3" instead of 6'2" pushed you further DOWN.
        That was the reported bug.)
         - waist known  -> trust it, then nudge up for rise/inseam (height) and hips/thighs (build).
         - waist blank  -> estimate straight from height + weight. Weight is already the main
                           driver here, so the build nudge is NOT re-applied (it would double-count). */
    function effectiveWaist() {
      var b = bodyMetrics();
      var waist = parseFloat(st.waist);
      if (st.unit !== 'us' && waist > 0) waist = waist / 2.54;   // cm -> in
      if (waist > 0) {
        var heightUp = clamp((b.heightIn - 70) * 0.10, 0, 0.9);   // taller -> more rise/inseam
        var leanRefW = 110 + (b.heightIn - 60) * 4;               // lean reference weight for height
        var buildUp  = clamp((b.weightLb - leanRefW) * 0.015, 0, 0.6);
        return waist + heightUp + buildUp;
      }
      /* Anchored on a 6'3" / 175 lb / 32" waist body reading L, plus a ~0.75" brand lean up. */
      return 32.75 + (b.weightLb - 175) * 0.095 + (b.heightIn - 75) * 0.05;
    }

    /* What the shopper says they normally wear beats our estimate when the two are close.
       Sizing varies brand to brand and US vs EU, so a wildly different answer only moves us
       one step toward them rather than overriding outright. */
    function applyUsual(key) {
      if (!st.usual) return key;
      var mi = ORDER.indexOf(key), ui = ORDER.indexOf(st.usual);
      if (mi < 0 || ui < 0) return key;
      if (Math.abs(ui - mi) <= 1) return st.usual;
      return ORDER[mi + (ui > mi ? 1 : -1)];
    }

    function recommend() {
      var w = effectiveWaist();
      var key = 'XL';
      for (var i = 0; i < CFG.sizes.length; i++) { if (w <= CFG.sizes[i].max) { key = CFG.sizes[i].key; break; } }
      key = applyUsual(key);
      var avail = availableWaists();
      if (avail.length && avail.indexOf(key) === -1) {
        var idx = ORDER.indexOf(key);
        var best = avail[0], bestD = 99;
        avail.forEach(function (a) { var d = Math.abs(ORDER.indexOf(a) - idx); if (d < bestD) { bestD = d; best = a; } });
        key = best;
      }
      // Length is height-aware: on a shorter frame the Regular hem already sits at/below
      // the knee, so reserve Long for taller bodies (>= 5'8", our shortest Long-wearing model).
      var length = 'Regular';
      if (st.fit === 'below' && bodyMetrics().heightIn >= 68) length = 'Long';
      return { key: key, length: length };
    }

    /* ---------- auto-select on the buy box ---------- */
    function applySelection(r) {
      var wBtn = pdp.querySelector('[data-waist="' + r.key + '"]');
      if (wBtn && !wBtn.disabled) wBtn.click();
      var lBtn = pdp.querySelector('[data-length="' + r.length + '"]');
      if (lBtn) {
        if (lBtn.disabled) {
          var altLen = (r.length === 'Long') ? 'Regular' : 'Long';
          var alt = pdp.querySelector('[data-length="' + altLen + '"]');
          if (alt && !alt.disabled) { alt.click(); r.length = altLen; }
        } else { lBtn.click(); }
      }
    }

    /* ---------- step 3: loading animation -> result (slow, readable) ---------- */
    var loadCells = $$('[data-ff-load]');
    var loadBar = $('[data-ff-loadbar]');
    var loadTimers = [];
    var STEP_MS = 1500;               // dwell per message
    function clearLoad() { loadTimers.forEach(clearTimeout); loadTimers = []; }
    function runLoading() {
      showStep(3);
      loadCells.forEach(function (c) { c.classList.remove('is-on', 'is-done'); });
      if (loadBar) loadBar.style.width = '0';
      clearLoad();
      [0, 1, 2].forEach(function (i) {
        loadTimers.push(setTimeout(function () {
          if (i > 0) { loadCells[i - 1].classList.remove('is-on'); loadCells[i - 1].classList.add('is-done'); }
          loadCells[i].classList.add('is-on');
          if (loadBar) loadBar.style.width = ((i + 1) / 3 * 100) + '%';
        }, i * STEP_MS));
      });
      loadTimers.push(setTimeout(function () {
        loadCells[2].classList.remove('is-on'); loadCells[2].classList.add('is-done');
        showResult();
      }, 3 * STEP_MS));
    }

    /* ---------- step 4: result ---------- */
    function showResult() {
      rec = recommend();
      applySelection(rec);                 // preselect on the buy box immediately
      if (resultEl) {
        resultEl.innerHTML = rec.key +
          ' <span class="jkff__resLen">&middot; ' + (rec.length === 'Long' ? 'Long' : 'Regular') + ' length</span>';
      }
      showStep(4);
    }

    $('[data-ff-edit]').addEventListener('click', function () { showStep(0); });
    $('[data-ff-add]').addEventListener('click', function () {
      if (rec) applySelection(rec);
      close();
      var atc = pdp.querySelector('[data-atc]');
      if (atc) setTimeout(function () { atc.click(); }, 60);
    });

    /* ---------- open / close ---------- */
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      clearLoad();
      showStep(0);
      setTimeout(function () { try { (st.unit === 'us' ? hft : hcm).focus(); } catch (e) {} }, 80);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      clearLoad();
    }
    $$('[data-open-fitfinder]', document).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $$('[data-jkff-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  });
})();
